import React, { useState, useEffect} from 'react';
import { Grid, Typography, Box, Button } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import VerifiedIcon from '@mui/icons-material/Verified';
import useStyles from '../styles/styles';
import { useTranslation } from "react-i18next";
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import CarCrashOutlinedIcon from '@mui/icons-material/CarCrashOutlined';
import backImage from '../assets/img/back.png';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { FONT_FAMILY} from "../common/sharedFunctions";
import { colors } from './Theme/WebTheme';
import { getLangKey } from 'common/src/other/getLangKey';
import { MOVEX_UI } from '../common/movexUiTheme';

const ACCENT = MOVEX_UI.accent;

const Section = (props) => {
  const settings = useSelector(state => state.settingsdata.settings);
  const classes = useStyles();
  const { t } = useTranslation();
  const cartypes = useSelector(state => state.cartypes);
  const [data, setData] = useState([]);
  const auth = useSelector(state => state.auth);
  const [loggedIn, setLoggedIn] = useState(false);

  function formatAmount(value, decimal, country) {
    const number = parseFloat(value || 0);
    if (country === "Vietnam") {
      return number.toLocaleString("vi-VN", {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal
      });
    } else {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal
      });
    }
  }

  useEffect(() => {
    if (cartypes.cars) {
      setData(
        cartypes.cars
          .filter(car => car.category === settings.appCat)
          .sort((a, b) => a.pos - b.pos)
      );
    } else {
      setData([]);
    }
  }, [cartypes.cars, settings.appCat]);

  useEffect(()=>{
    if(auth.profile && auth.profile.uid){
      setLoggedIn(true);
    }else{
      setLoggedIn(false);
    }
  },[auth.profile]);

  const navigate = useNavigate();
  const role = props.role;
  const color=props.color;
  
  const sectionItems = [
    {
      id: 1,
      icon:  <EmojiTransportationIcon style={{ color: ACCENT, fontSize: '30px', marginRight: 5 }} />,
      sentence1:t('pruduct_section_heading_1'),
      sentence: t('product_section_1'),
    },
    {
      id: 2,
      icon:  <AccessTimeIcon style={{ color: ACCENT, fontSize: '30px', marginRight: 8 }} />,
      sentence1:t('pruduct_section_heading_2'),
      sentence: t('product_section_2'),
    },
  ];
  const sectionItems1 = [
    {
      id: 1,
      icon:   <CarCrashOutlinedIcon style={{ color: ACCENT, fontSize: '30px', marginRight: 8 }} />,
      sentence1:t('pruduct_section_heading_3'),
      sentence: t('product_section_3'),
    },
    {
      id: 2,
      icon:  <VerifiedIcon style={{ color: ACCENT, fontSize: '30px', marginRight: 8 }} />,
      sentence1:t('pruduct_section_heading_4'),
      sentence: t('product_section_4'),
    },
  ];

  const Boxs = () => {
    return(
      <Box id="car-types" sx={{ flexGrow: 1, minHeight: data.length > 0 ? '480px' : '160px', marginTop: 7, marginBottom: 1, scrollMarginTop: '90px' }}>
        {data && data.length > 0 ?
          <Box sx={{ textAlign: 'center', mb: 4, px: 2 }}>
            <Typography component="h2" sx={{ fontFamily: FONT_FAMILY, fontWeight: 'bold', fontSize: { xs: 26, md: 36 }, color: '#111' }}>
              {t('section_cars_title', { defaultValue: 'Elige tu tipo de grúa' })}
            </Typography>
            <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: { xs: 15, md: 17 }, color: '#666', mt: 1, maxWidth: 640, mx: 'auto' }}>
              {t('section_cars_sub', { defaultValue: 'Tarifas claras por kilómetro y tiempo estimado antes de confirmar. Sin sorpresas.' })}
            </Typography>
          </Box>
          : null}
        {data && data.length > 0 ?
          <Grid container className={classes.sectionGridContainer} sx={{ flexWrap: 'wrap', gap: 1 }}>
            {data.map((item, key) => {
              return (
                <div style={{marginBottom: 40}} key={key}>
                  <Box
                    className={`${classes.sectionGridItem} ai-glow-card`}
                    style={{
                      backgroundColor: '#fff',
                      textAlign: 'center',
                      width: 300,
                      minWidth: 280,
                      borderRadius: 24,
                      padding: 14,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      border: `1px solid ${MOVEX_UI.cardBorder}`,
                      boxShadow: MOVEX_UI.cardShadow,
                    }}
                  >
                    <Box
                      style={{
                        width: '100%',
                        height: 140,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: 6,
                      }}
                    >
                      <img
                        alt={t(getLangKey(item.name))}
                        src={item.image}
                        style={{ maxWidth: '88%', maxHeight: 120, width: 'auto', height: 'auto', objectFit: 'contain' }}
                      />
                    </Box>
                    <Typography component="h3" style={{ margin: '4px 0 12px', color: 'black', fontSize: 22, fontWeight: 'bold', fontFamily: FONT_FAMILY }}>{t(getLangKey(item.name))}</Typography>
                    <Box style={{ backgroundColor: 'white', width: '100%', borderRadius: 20, padding: 16, display: 'flex', flexDirection: 'column', alignItems: 'center' }} boxShadow={2}>
                      {settings.swipe_symbol === false ?
                        <Typography style={{ fontWeight: 'bold', fontSize: 26, fontFamily: FONT_FAMILY, color: '#111' }}>{settings.symbol}{formatAmount(item.rate_per_unit_distance, settings.decimal, settings.country)}<span style={{ fontSize: 15, fontWeight: 'normal', color: '#666' }}>/{settings.convert_to_mile ? t('mile') : t('km')}</span></Typography>
                        :
                        <Typography style={{ fontWeight: 'bold', fontSize: 26, fontFamily: FONT_FAMILY, color: '#111' }}>{formatAmount(item.rate_per_unit_distance, settings.decimal, settings.country)}{settings.symbol}<span style={{ fontSize: 15, fontWeight: 'normal', color: '#666' }}>/{settings.convert_to_mile ? t('mile') : t('km')}</span></Typography>
                      }
                      <Typography style={{ marginTop: 8, fontSize: 14, color: '#444', fontFamily: FONT_FAMILY }}>{t('min_fare')}: <strong>{item.min_fare}</strong></Typography>
                      {item.extra_info ?
                        <Typography style={{ marginTop: 4, fontSize: 13, color: '#777', fontFamily: FONT_FAMILY, minHeight: 36 }}>{item.extra_info}</Typography>
                        : <div style={{ minHeight: 36 }} />}
                      <Button
                        variant="contained"
                        sx={{
                          width: '100%',
                          fontSize: '16px',
                          marginTop: 2,
                          borderRadius: '12px',
                          paddingY: 1.1,
                          fontFamily: FONT_FAMILY,
                          textTransform: 'none',
                          fontWeight: 700,
                          background: `linear-gradient(135deg, ${MOVEX_UI.accent} 0%, ${MOVEX_UI.accentDark} 100%)`,
                          boxShadow: 'none',
                          '&:hover': {
                            background: `linear-gradient(135deg, ${MOVEX_UI.accentDark} 0%, #078a2a 100%)`,
                            boxShadow: MOVEX_UI.cardShadowHover,
                          },
                        }}
                        onClick={(e) => { e.preventDefault();
                          if(loggedIn){
                          navigate(((role && role === 'driver' )|| (settings && settings.appCat === 'bidcab' && (role === 'admin' || role === 'fleetadmin'))) ? '/bookings' : '/addbookings',
                          { state: { carData: item }} )
                          }else{
                            navigate('/login')
                          }
                        }}
                      >
                        { role === 'driver' || (settings && settings.appCat === 'bidcab' && (role === 'admin' || role === 'fleetadmin')) ? t('info'): t('book_now')}
                      </Button>
                    </Box>
                  </Box>
                </div>
              )
            })}
          </Grid>
        :
          <Typography variant="h3" fontWeight={400} style={{ textAlign: 'center', padding: 35, color: color.Header}}>{t('service_start_soon')}</Typography>
        }
      </Box>
    )
  }

  return (
    <div>
          <Boxs/>

      <Box sx={{
        flexGrow: 1,
        minHeight: '350px',
        backgroundImage: `linear-gradient(rgba(5,5,5,0.82), rgba(10,46,26,0.88)), url(${backImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        py: 4,
      }}>
        <Typography variant="h3" fontWeight={700} style={{ color: '#fff', fontFamily: FONT_FAMILY, textAlign: 'center', padding: '24px 16px' }}>{t('best_service_provider')}</Typography>
        <Grid container className={classes.sectionGridContainer}>
          {sectionItems.map((item, key) => {
            return (
              <Box
                key={key}
                xs={12}
                md={3.5}
                minHeight={150}
                className={classes.sectionGridItem1}
              >
                <div style={{display:'flex'}}>
                  {item.icon}
                  <div>
                    <Typography variant="h5" style={{ color: ACCENT, fontFamily: FONT_FAMILY, fontWeight: 'bold'}}>{item.sentence1}</Typography>
                    <Typography style={{ color:colors.WHITE, fontFamily:FONT_FAMILY,}} className={classes.aboutUsSubtitle}>{item.sentence}</Typography>
                  </div>
                </div> 
              </Box>
            )
          })}
        </Grid>

        <Grid container className={classes.sectionGridContainer}>
          {sectionItems1.map((item, key) => {
            return (
              <Box
                key={key}
                xs={12}
                md={3.5}
                minHeight={150}
                
                className={classes.sectionGridItem1}
              >
                <div style={{display:'flex'}}>
                  {item.icon}
                  <div>
                    <Typography variant="h5" style={{ color: ACCENT, fontFamily: FONT_FAMILY, fontWeight: 'bold' }}>{item.sentence1}</Typography>
                    <Typography style={{ color:colors.WHITE, fontFamily:FONT_FAMILY,}} className={classes.aboutUsSubtitle}>{item.sentence}</Typography>
                  </div>
                </div> 
              </Box>
            )
          })}
        </Grid>
      </Box>
    </div>
  );
};

export default Section;